import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const WHATSAPP_NUMBER = "61469076071"; // 0469 076 071 in international format
const WHATSAPP_MSG = encodeURIComponent(
    "Hi Leo's Luxury, I'd like to chat about hosting my property.",
);

export default function FloatingActions() {
    const [show, setShow] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 520);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onAdmin = location.pathname.startsWith("/admin");
    if (onAdmin) return null;

    const hideConsult = location.pathname === "/contact";

    return (
        <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
            {/* WhatsApp — always visible */}
            <a
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="whatsapp-float-button"
                className="group relative w-14 h-14 flex items-center justify-center bg-[#25D366] text-white shadow-[0_14px_36px_-10px_rgba(37,211,102,0.7)] transition-transform duration-500 hover:-translate-y-1"
            >
                <span
                    className="absolute inset-0 bg-[#25D366] animate-ping opacity-30"
                    style={{ animationDuration: "2.4s" }}
                />
                <svg
                    viewBox="0 0 24 24"
                    className="relative w-7 h-7 fill-current"
                    aria-hidden="true"
                >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.464 3.488" />
                </svg>
            </a>

            {/* Book consultation — appears on scroll */}
            <AnimatePresence>
                {show && !hideConsult && (
                    <motion.div
                        initial={{ opacity: 0, y: 16, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 16, scale: 0.96 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <Link
                            to="/contact"
                            data-testid="floating-consultation-button"
                            className="btn-gold"
                        >
                            <Calendar size={15} strokeWidth={1.6} />
                            <span>Book Consultation</span>
                        </Link>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
